import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser deve ser usado dentro de um UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rolesInfo, setRolesInfo] = useState({});

  // Carregar informações do usuário do localStorage
  useEffect(() => {
    const loadUserFromStorage = () => {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('userData');
      
      if (token && userData) {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
        } catch (error) {
          console.error('Erro ao carregar dados do usuário:', error);
          localStorage.removeItem('userData');
        }
      }
      setLoading(false);
    };

    loadUserFromStorage();
  }, []);

  // Função para atualizar dados do usuário
  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('userData', JSON.stringify(userData));
  };

  // Função para fazer logout
  const logout = () => {
    setUser(null);
    setRolesInfo({});
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
  };

  // Função para verificar se o usuário tem uma role específica
  const hasRole = (role) => {
    return user?.role === role;
  };

  // Função para verificar se o usuário é master
  const isMaster = () => {
    return user?.role === 'master';
  };

  // Função para verificar se o usuário é admin
  const isAdmin = () => {
    return user?.role === 'admin' || user?.role === 'master';
  };

  // Função para verificar se o usuário pode gerenciar produtos
  const canManageProducts = () => {
    return isAdmin();
  };

  // Função para verificar se o usuário pode gerenciar usuários
  const canManageUsers = () => {
    return isAdmin();
  };

  // Função para verificar se o usuário pode acessar logs
  const canAccessLogs = () => {
    return isAdmin();
  };

  // Função para verificar se o usuário pode modificar outro usuário
  const canModifyUser = (targetUser) => {
    // Master pode modificar qualquer usuário exceto outro master
    if (isMaster()) {
      return targetUser.role !== 'master';
    }
    
    // Admin pode modificar usuários normais
    if (isAdmin()) {
      return targetUser.role === 'user';
    }
    
    return false;
  };

  const value = {
    user,
    loading,
    rolesInfo,
    setRolesInfo,
    updateUser,
    logout,
    hasRole,
    isMaster,
    isAdmin,
    canManageProducts,
    canManageUsers,
    canAccessLogs,
    canModifyUser
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}; 